import React from "react";
import _ from "lodash";

import PollGraph from "MessagingV2/components/PollsAndForms/PollGraph";

import PollFooter from "./PollFooter";
import classes from "./PollMessage.scss";
import { getUserId } from "modules/CommonSelectors";

const PollMessage = props => {
  const { message } = props;

  const messageId = _.get(message, "id");
  const attachment = _.first(_.get(message, "attachments", []));

  const createdBy = _.get(attachment, "createdBy");

  const isCreator = _.isEqual(_.get(createdBy, "id"), getUserId());

  const interaction = _.get(attachment, "interaction", {});

  const question = _.get(interaction, "question", "");

  return (
    <div className={classes.pollContainer}>
      <div className="text-body">{question}</div>
      <PollGraph
        interaction={interaction}
        messageId={messageId}
        isCreator={isCreator}
      />
      <div className={classes.pollMessageFooter}>
        <PollFooter
          interaction={interaction}
          isCreator={isCreator}
          messageId={messageId}
        />
      </div>
    </div>
  );
};

export default PollMessage;
